import { isAfter, parseISO } from "date-fns";
import type { BrazilianIssuerManagementReport } from "types/typedDocumentNodes";

interface ICurrentManagementReportAnchorProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  lastQuarterlyManagementReport: BrazilianIssuerManagementReport | null;
  lastYearlyManagementReport: BrazilianIssuerManagementReport | null;
  reportSource?: BrazilianIssuerManagementReport | null;
  children?: React.ReactNode;
}

export default function CurrentManagementReportAnchor({
  lastQuarterlyManagementReport,
  lastYearlyManagementReport,
  reportSource,
  children,
  ...props
}: ICurrentManagementReportAnchorProps) {
  if (reportSource) {
    if (reportSource.type === "ITR") {
      return (
        <a href={reportSource.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
          {children || "Relatório da Administração (Trimestral)"}
        </a>
      );
    }

    if (reportSource.type === "DFP") {
      return (
        <a href={reportSource.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
          {children || "Relatório da Administração (Anual)"}
        </a>
      );
    }
  }

  if (lastQuarterlyManagementReport && lastYearlyManagementReport) {
    const lastQuarterlyDateOfReference = parseISO(lastQuarterlyManagementReport.dateOfReference);
    const lastYearlyDateOfReference = parseISO(lastYearlyManagementReport.dateOfReference);
    if (isAfter(lastQuarterlyDateOfReference, lastYearlyDateOfReference)) {
      return (
        <a href={lastQuarterlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
          {children || "Relatório da Administração (Trimestral)"}
        </a>
      );
    }
    return (
      <a href={lastYearlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
        {children || "Relatório da Administração (Anual)"}
      </a>
    );
  }
  if (lastQuarterlyManagementReport && !lastYearlyManagementReport) {
    return (
      <a href={lastQuarterlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
        {children || "Relatório da Administração (Trimestral)"}
      </a>
    );
  }
  if (!lastQuarterlyManagementReport && lastYearlyManagementReport) {
    return (
      <a href={lastYearlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
        {children || "Relatório da Administração (Anual)"}
      </a>
    );
  }
  return null;
}
